import Vue from 'vue'
import VueRouter from 'vue-router'
import ProductView from '../views/ProductView.vue'
import ProductBackView from '../views/ProductBackView.vue'
import BaiduView from '../views/BaiduView.vue'
import AHproView from '@/views/AHproView.vue'
import GDproView from '@/views/GDproView.vue'
import FilingView from '@/views/FilingView.vue'
import GongMaoView from '@/views/GMaoView.vue'
import XYKSView from '@/views/XYKSView.vue'
import NanJingPro from '@/views/NanJingPro.vue'
import GroupView from '@/views/GroupView.vue'
import { getOrderSourceStatus } from '@/assets/js/api'

Vue.use(VueRouter)

const routes = [
  // 新落地页
  {
    path: '/',
    name: 'bdmp',
    component: BaiduView,
  },
  {
    path: '/gprom',
    name: 'gprom',
    component: GongMaoView,
  },

  {
    path: '/product',
    name: 'product',
    component: ProductView,
  },
  {
    path: '/productBack',
    name: 'productBack',
    component: ProductBackView,
  },
  {
    path: '/bdmp',
    name: 'bdmp',
    component: BaiduView,
  },

  {
    path: '/audit',
    name: 'filing',
    component: FilingView,
  },
  {
    path: '/aproh',
    name: 'aproh',
    component: AHproView,
  },
  {
    path: '/gprod',
    name: 'gprod',
    component: GDproView,
  },
  {
    path: '/xyks',
    name: 'xyks',
    component: XYKSView,
  },
  {
    path: '/njzdwh',
    name: 'njzdwh',
    component: NanJingPro,
  },
  {
    path: '/group',
    name: 'group',
    component: GroupView,
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('@/views/ProductList.vue'),
  },
  {
    path: '/veterans',
    name: 'veterans',
    component: () => import('@/views/VeteransView.vue'),
  },
  {
    path: '/veterans_hubei',
    name: 'veterans_hubei',
    component: () => import('@/views/VeteransHuBei.vue'),
  },
  {
    path: '/veterans_anhui',
    name: 'veterans_anhui',
    component: () => import('@/views/VeteransAnHui.vue'),
  },
  {
    path: '/veterans_ningbo',
    name: 'veterans_ningbo',
    component: () => import('@/views/VeteransNingBo.vue'),
  },
  {
    path: '/veterans_beijing',
    name: 'veterans_beijing',
    component: () => import('@/views/VeteransBeiJing.vue'),
  },
  {
    path: '/group_ningbo',
    name: 'group_ningbo',
    component: () => import('@/views/GroupNingBo.vue'),
  },
  {
    path: '/group_wuwei',
    name: 'group_wuwei',
    component: () => import('@/views/Group_wuwei.vue'),
  },
  {
    path: '/group_hubei',
    name: 'group_hubei',
    component: () => import('@/views/Group_hubei.vue'),
  },
  {
    path: '/group_anhui',
    name: 'group_anhui',
    component: () => import('@/views/Group_anhui.vue'),
  },
  {
    path: '/group_beijing',
    name: 'group_beijing',
    component: () => import('@/views/Group_beijing.vue'),
  },
  {
    path: '/group_chengdu',
    name: 'group_chengdu',
    component: () => import('@/views/Group_chengdu.vue'),
  },
  {
    path: '/shanxi_number',
    name: 'shanxi_number',
    component: () => import('@/views/ShanxiNumber.vue'),
  },

  {
    path: '/equity',
    name: 'equity',
    component: () => import('@/views/EquityView.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/NotFound.vue'),
  },
  {
    path: '*',
    name: '404页面',
    component: () => import('@/views/NotFound.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.path == '/list') {
    document.title = '手机卡流量卡线上营业厅'
  }

  next()
})
export default router
